import styled from "styled-components";

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  margin: 0 1%;
  @media (max-width: 2560px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
  @media (max-width: 1444px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 425px) {
    grid-template-columns: 1fr;
  }
`;

export const PromocaoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: auto;
  max-height: 450px;
  max-width: 450px;
  margin: 10px 10px;
  &:hover {
    cursor: pointer;
  }
`;

export const Imagem = styled.img`
  top: 0;
  left: 0;
  width: 100%;
  /* height: 100%; */
  &:hover {
    transition: 10ms;
    filter: contrast(200%) brightness(150%);
  }
`;

export const Titulo = styled.h1`
  display: flex;
  font-size: calc(14px + 1vw);
  font-weight: bold;
  align-items: center;
  justify-content: center;
  margin: 15px;
`;

export const Descricao = styled.h1``;

export const Texto = styled.p`
  display: flex;
  justify-content: stretch;
  align-self: stretch;
  margin: 15px 30px;
  font-size: calc(10px + 1vw);
`;

export const Action = styled.a`
  :link {
    color: #000;
  }
  :visited {
    color: #000;
  }
  :hover {
    color: #0001;
  }
  :active {
    color: #000;
  }
`;

export const Mensagem = styled.h1``;
